import { AxiosResponse } from "axios";
import { keeperToast } from "components/keeperToast";
import { useMutation } from "react-query";
import { processKeeperRecords } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

// Define the hook
const useProcessKeeperRecords = ({ setIsSaving, setKeeperRecords }) => {
  return useMutation<AxiosResponse<any>, Error, File | null>({
    mutationFn: processKeeperRecords,
    onMutate: () => {
      keeperToast.fire(
        "Processing Data",
        "Producer Code mapping to keeper inprogress. This may take a moment.",
        "info"
      );
    },
    onSuccess: (res) => {
      if (res.data == "File is empty") {
        keeperToast.fire("Invalid File", "File is empty", "warning");
      } else if (res.data == "Only Excel files are allowed") {
        keeperToast.fire(
          "Invalid File",
          "Only Excel files are allowed. Please upload a valid file.",
          "warning"
        );
      } else if (res.status === 400) {
        keeperToast.fire(
          "Invalid File",
          "Please check your file and try again",
          "warning"
        );
      } else if (res.status === 200 || res.status === 201) {
        keeperToast.fire(
          "Saved Successfully",
          "Successfully mapped to keeper",
          "success"
        );
      } else {
        keeperToast.fire("Error", "Saving Failed: Server Error", "error");
      }
      setIsSaving(false);
      setKeeperRecords(null);
    },
    onError: (error) => {
      keeperToast.fire(
        "Mapped to keeper process failed",
        "Server Error: There's a problem processing keeper mapping",
        "error"
      );
      setIsSaving(false);
      setKeeperRecords(null);
    },
  });
};

export default useProcessKeeperRecords;
